/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PreHeadersQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  channel: Types.Channel;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type PreHeadersQuery = {
  __typename?: 'Query';
  preHeaders: Array<{
    __typename?: 'PreHeader';
    id: string;
    message?: string;
    className?: string;
    countdownEndAt?: any;
    advertiser?: string;
    sponsor?: string;
    userSegments?: any;
    link?: {
      __typename?: 'Link';
      label?: string;
      url: string;
      target?: string;
    };
    abTest?: { __typename?: 'ABTest'; id: number; feature: string };
    featureFlag?: { __typename?: 'FeatureFlag'; id: number; active?: boolean };
    image?: {
      __typename?: 'PreHeaderImage';
      desktopUrl?: string;
      mobileUrl?: string;
      altText: string;
    };
  }>;
};

export const PreHeadersDocument = /*#__PURE__*/ `
    query PreHeaders($platform: Platform!, $market: Market!, $channel: Channel!, $userSegments: Map) {
  preHeaders(
    platform: $platform
    channel: $channel
    market: $market
    userSegments: $userSegments
  ) {
    id
    message
    link {
      label
      url
      target
    }
    className
    abTest {
      id
      feature
    }
    featureFlag {
      id
      active
    }
    image {
      desktopUrl
      mobileUrl
      altText
    }
    countdownEndAt
    advertiser
    sponsor
    userSegments
  }
}
    `;

export function usePreHeadersQuery(
  options: Omit<Urql.UseQueryArgs<PreHeadersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PreHeadersQuery, PreHeadersQueryVariables>({
    query: PreHeadersDocument,
    ...options,
  });
}
